<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="80%"
    @opened="openDrawer" :wrapperClosable="false">

    <!-- 基本信息表单 -->
    <div class="form-box">



      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">


          <!-- 下拉选择端口 -->
          <el-form-item label="选择端口:" label-width='120px'>

            <el-select v-model="value_port_code" placeholder="请选择端口" style="width: 150px; margin-right: 20px;"
              @change="portChange" clearable>

              <el-option :label="item.alias" :value="item.val" v-for="(item, index) in port_select_arrway" :key="index">
              </el-option>

            </el-select>

          </el-form-item>

          <!-- 下拉选择置顶等级 -->
          <el-form-item label="选择置顶等级:" label-width='120px'>

            <el-select v-model="value_top_code" placeholder="请选择置顶等级" style="width: 150px; margin-right: 20px;"
              @change="topChange" clearable>

              <el-option :label="item.alias" :value="item.val" v-for="(item, index) in top_select_arrway" :key="index">
              </el-option>

            </el-select>

          </el-form-item>

          <!-- 下拉选择置顶等级 -->
          <el-form-item label="选择推送:" label-width='120px'>

            <el-select v-model="value_push_code" placeholder="请选择推送" style="width: 150px; margin-right: 20px;"
              @change="pushChange" clearable>

              <el-option :label="item.alias" :value="item.val" v-for="(item, index) in push_select_arrway" :key="index">
              </el-option>

            </el-select>

          </el-form-item>




          <el-form-item label="公告标题:" label-width='120px'>
            <el-input v-model="submit_data.title" :placeholder="submit_rules.title.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="公告副标题:" label-width='120px'>
            <el-input v-model="submit_data.keywords" :placeholder="submit_rules.keywords.placeholder"
              style="width: 80%;">
            </el-input>
          </el-form-item>


          <el-form-item label="公告内容:" label-width='120px'>

            <quill-editor ref="myTextEditor" v-model="submit_data.content" :options="submit_rules.content">
            </quill-editor>

          </el-form-item>


          <el-form-item label="权重等级:" label-width='120px'>

            <el-select v-model="submit_data.weights" placeholder="请选择权重等级" style="width: 150px; margin-right: 20px;"
              clearable>

              <el-option label="1" value="1"></el-option>
              <el-option label="2" value="2"></el-option>
              <el-option label="3" value="3"></el-option>
              <el-option label="4" value="4"></el-option>
              <el-option label="5" value="5"></el-option>
              <el-option label="6" value="6"></el-option>
              <el-option label="7" value="7"></el-option>
              <el-option label="8" value="8"></el-option>
              <el-option label="9" value="9"></el-option>

            </el-select>

          </el-form-item>



        </el-form>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center;margin-top: 20px;">
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>

    </div>

  </el-drawer>
</template>

<script>
  var _this;
  import {
    config
  } from '../../../utils/config'; // 配置
  import axios from 'axios'; // AJAX封装类

  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import {
    quillEditor
  } from 'vue-quill-editor';
  export default {
    components: {
      quillEditor
    },
    props: {
      isShow: Boolean,
      data: ''
    },
    watch: {
      isShow(newData, oldData) {
        console.log(_this.data);

        _this.show = true;


      }
    },
    data() {
      return {


        show: false,



        // 选择端口下拉
        value_port_code: '',
        port_select_arrway: {},

        // 选择端口下拉
        value_top_code: '',
        top_select_arrway: {},

        // 选择端口下拉
        value_push_code: '',
        push_select_arrway: {},




        // 表单数据
        submit_data: {
          title: '',
          keywords: '',
          content: '',
          top: '',
          port: '',
          weights: '',
          push: ''
        },

        submit_rules: {

          title: {
            placeholder: '请输入公告标题',
            rules: {
              required: true,
              message: '公告标题最少为4字以上',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          keywords: {
            placeholder: '公告副标题',
            rules: {
              required: true,
              message: '公告副标题小于1000字',
              regulation: 'lt_str',
              rulesData: 1000
            }
          },
          content: {
            placeholder: '请输入公告内容',
            rules: {
              required: true,
              message: '公告内容最少为5字以上',
              regulation: 'gt_str',
              rulesData: 5
            }
          },
          weights: {
            placeholder: '请输入权重等级',
            rules: {
              required: true,
              message: '权重等级错误',
              regulation: 'lt',
              rulesData: 10
            }
          },
          top: {
            placeholder: '请输入置顶等级',
            rules: {
              required: true,
              message: '置顶等级错误',
              regulation: 'special',
              rulesData: '0|1'
            }
          },
          push: {
            placeholder: 'APP推送',
            rules: {
              required: true,
              message: 'APP推送错误',
              regulation: 'special',
              rulesData: '0|1'
            }
          }
        },
      };
    },
    created() {
      _this = this;
    },
    methods: {
      openDrawer() {
        // 获取广告详情

        _this.$post('/notice/getNoticeDetails', {
            notice_code: _this.data
          })
          .then(res => {

            _this.submit_data.notice_code = res.data.notice_code;
            _this.submit_data.title = res.data.title;
            _this.submit_data.keywords = res.data.keywords;

            _this.submit_data.content = res.data.content;

            _this.submit_data.top = res.data.top.val;
            _this.submit_data.weights = res.data.weights;
            _this.submit_data.port = res.data.port.val;
            _this.submit_data.push = res.data.push.val;



            _this.value_port_code = res.data.port.alias;
            _this.value_push_code = res.data.push.alias;
            _this.value_top_code = res.data.top.alias;

            _this.port_select_arrway = res.data.port.select_array;
            _this.top_select_arrway = res.data.top.select_array;
            _this.push_select_arrway = res.data.push.select_array;


          })
          .catch(res => {});
      },
      portChange(val) {
        console.log(val);

        _this.submit_data.port = String(val);

      },

      topChange(val) {
        console.log(val);

        _this.submit_data.top = String(val);

      },

      pushChange(val) {
        console.log(val);

        _this.submit_data.push = String(val);

      },





      // 关闭方法
      closeDialog() {
        _this.show = false;
        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

        _this.value_port_code = '';
        _this.value_mode_code = '';
        _this.value_push_code = '';
        _this.value_top_code = '';
        _this.company_name = '';
      },

      portChange(val) {
        console.log(val);

        _this.submit_data.port = val;
      },
      modeChange(val) {
        _this.submit_data.mode = val;
      },

      // 提交
      onSubmit() {
        console.log(_this.submit_data);

        _this
          .$post('/notice/editNoticeSubmit', _this.submit_data, _this.submit_rules)
          .then(res => {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
            this.$message.success(res.msg);
          })
          .catch(res => {});
      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .verify_remarks {
    font-size: 14px;
    color: #606266;
  }

  .quill-editor {
    width: 80%;
  }
</style>